import { Link } from "react-router-dom";
import { allComics } from "@/mocks/comics";

export default function HeroSection() {
  const featured = allComics.slice(0, 3);

  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={featured[0]?.coverLarge}
          alt="韩漫在线免费 - 土豪漫画网"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-50/40 via-background-50/30 to-background-50" />
      </div>
      <div className="relative z-10 w-full mx-auto max-w-7xl px-4 md:px-6 pt-20 pb-10">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            韩漫在线免费
            <span className="block text-primary-500">下拉式阅读新体验</span>
          </h1>
          <p className="mt-4 text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            土豪漫画网提供<strong>韩漫全集下拉式阅读</strong>服务，收录<strong>韩国漫画大全</strong>，
            让您轻松浏览各种精彩作品，无需下载即可享受沉浸式阅读乐趣。
          </p>
          <div className="mt-7 flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/category/all"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              浏览漫画大全
            </Link>
            <Link
              to="/category/rexue"
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="px-6 py-2.5 rounded-full bg-background-100/80 text-foreground-700 text-sm font-medium hover:bg-background-200 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              热门推荐
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto">
          {featured.map((comic, idx) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              className="group relative bg-background-50/90 backdrop-blur-sm rounded-xl p-3 flex items-center gap-3 hover:bg-background-100 transition-all duration-300 cursor-pointer"
            >
              <div className="w-14 h-20 flex-shrink-0 rounded-md overflow-hidden bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="min-w-0">
                <span className="text-xs text-primary-500 font-semibold">
                  TOP {idx + 1}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mt-0.5 line-clamp-1 group-hover:text-primary-500 transition-colors duration-200">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}